// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"no-z","badgeLink":"oo-z","category":"po-z"};